import { Link } from 'react-router-dom';

export default function SobreMiSection() {
  return (
    <section id="sobre-mi" className="relative bg-background-50 py-20 md:py-28 lg:py-32">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Photo */}
          <div className="lg:col-span-5 reveal-on-scroll">
            <div className="relative flex justify-center">
              <div className="relative w-[200px] h-[200px] md:w-[260px] md:h-[260px] lg:w-[300px] lg:h-[300px]">
                <div className="w-full h-full overflow-hidden rounded-full ring-1 ring-background-300/70">
                  <img
                    src="https://storage.helloreaddy.io/project_files/051d548c-4efa-4d12-87d7-897fd5389524/b62278c4-e49c-427a-bfad-0f6cc626b5ec_compressed_WhatsApp-Image-2026-10-03-at-1.54.14-PM.webp"
                    alt="Erika López Castañeda, mentora de reflexión estratégica"
                    className="w-full h-full object-cover object-top saturate-[0.85] contrast-[1.02]"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-7 reveal-on-scroll">
            <p className="text-[11px] md:text-xs tracking-[0.28em] uppercase text-accent-600 mb-5">
              Sobre Erika
            </p>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-[56px] leading-[1.05] font-light text-foreground-900 mb-8">
              Reflexiva. Respetuosa. Directa. Cercana.
            </h2>

            <div className="space-y-5 text-foreground-600 text-base md:text-lg leading-relaxed max-w-[560px]">
              <p>
                Aplico mi experiencia como ejecutiva global y mi especialización en liderazgo para
                ayudar a líderes a alcanzar su máximo potencial a través de un método propio de
                mentoría estratégica.
              </p>
              <p>
                Después de más de 20 años y una carrera progresiva en distintos roles de Recursos
                Humanos y desarrollo organizacional, dentro de un entorno corporativo global, te
                ofrezco la experiencia y la perspectiva necesarias para ayudarte a potenciar tu
                talento.
              </p>
            </div>

            <blockquote className="mt-9 border-l-2 border-accent-300 pl-6 py-1">
              <p className="font-heading text-xl md:text-2xl italic font-light text-foreground-800 leading-relaxed">
                Creo firmemente que las mejores decisiones nacen cuando hay calma interna, claridad
                mental y congruencia personal.
              </p>
            </blockquote>

            <div className="mt-10">
              <Link
                to="/sobre-mi"
                className="inline-block px-7 py-3.5 rounded-full text-sm font-medium tracking-[0.03em] whitespace-nowrap transition-all duration-300 cursor-pointer border border-foreground-900/20 text-foreground-900 hover:border-foreground-900/50 hover:bg-foreground-900/5"
              >
                Conoce más sobre mí
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}